<template>
  <CContainer class="align-items-center mt-5">
    <CRow class="justify-content-center">
      <CCol sm="6" lg="6">
        <CCardGroup>
          <CCard class="p-4">
            <CCardBody>
              <CForm>
                <h1>MT CRM</h1>
                <p class="text-muted">Trage deine Zugangsdaten ein um dich anzumelden.</p>
                <CInput
                  placeholder="E-Mail"
                  autocomplete="email"
                  v-model="email"
                >
                  <template #prepend-content><CIcon name="cil-user"/></template>
                </CInput>
                <CInput
                  placeholder="Password"
                  type="password"
                  autocomplete="curent-password"
                  v-model="password"
                >
                  <template #prepend-content><CIcon name="cil-lock-locked"/></template>
                </CInput>
                <CRow>
                  <CCol col="6">
                    <CButton  @click="doLogin" color="primary" class="px-4">Anmelden</CButton>
                  </CCol>
                </CRow>
              </CForm>
            </CCardBody>
          </CCard>
        </CCardGroup>
      </CCol>
    </CRow>
  </CContainer>
</template>

<script>
import { mapActions } from "vuex";

export default {
  name: 'Login',
  data: ()=>({
    email: '',
    password: '',
  }),

  methods: {
    ...mapActions('auth', [
      'login'
    ]),

    doLogin() {
      let data = {
        password: this.password,
        email: this.email,
      }

      this.login(data)
    }
  }
}
</script>
